import React, { useState } from "react";
import axios from "../../api/axios";
import ReportFilter from "./components/ReportFilter";

const SalesByAgent = () => {
  const [filters, setFilters] = useState({});
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchReport = async () => {
    setLoading(true);
    try {
        console.log('filters:', filters);
      const res = await axios.get("/api/reports/sales-by-agent", {
        params: filters,
      });

      console.log('response data:', res.data);

      setRows(res.data.data || []);
    } catch (err) {
      console.error("Failed to load sales by agent report", err);
      setRows([]);
    } finally {
      setLoading(false);
    }
  };

  const downloadPDF = async () => {
    try {
      const res = await axios.get("/api/reports/sales-by-agent/pdf", {
        params: filters,
        responseType: "blob",
      });
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "sales-by-agent-report.pdf");
      document.body.appendChild(link);
      link.click();
    } catch (err) {
      console.error("Failed to download PDF", err);
    }
  };

  const downloadCSV = async () => {
    try {
      const res = await axios.get("/api/reports/sales-by-agent/csv", {
        params: filters,
        responseType: "blob",
      });
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "sales-by-agent-report.csv");
      document.body.appendChild(link);
      link.click();
    } catch (err) {
      console.error("Failed to download CSV", err);
    }
  };

  return (
    <div className="container py-4">
      <h4 className="fw-bold mb-3">Sales By Agent</h4>

      <ReportFilter filters={filters} setFilters={setFilters} onSearch={fetchReport} />

      <div className="card shadow-sm">
        <div className="card-body">
          <div className="d-flex justify-content-end gap-2 mb-3">
            <button className="btn btn-outline-danger" onClick={downloadPDF}>
              PDF Download
            </button>
            <button className="btn btn-outline-secondary" onClick={downloadCSV}>
              CSV Download
            </button>
          </div>
          <table className="table table-bordered">
            <thead>
              <tr>
                <th>Role</th>
                <th>Total Sold Units</th>
              </tr>
            </thead>
            <tbody>
              {rows.length === 0 ? (
                <tr>
                  <td colSpan="2" className="text-center">
                    {loading ? "Loading..." : "No data"}
                  </td>
                </tr>
              ) : (
                rows.map((row, idx) => (
                  <tr key={idx}>
                    <td>{row.role}</td>
                    <td>{row.total_sold_units}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default SalesByAgent;

